import React, { Component } from 'react';
import { connect } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';
import { settingsPanel } from '../../../redux/actions/settings';
import "./styles.scss";

let scrollFlag = false;

class StoryPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            storySegment: {},
            analysis: {},
            index: this.props.index,
            fadeToggle: this.props.fadeToggle,
            fadeProp: null,
            textAnalysis: null,
            wordScore: []
        };
    }

    addAlpha = (color, opacity) => {
        // coerce values so ti is between 0 and 1.
        const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
        return color + _opacity.toString(16).toUpperCase();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.bbSettings !== this.props.bbSettings) {
            let sd = document.getElementById("storyDisplay");
            const { fontColor } = nextProps.bbSettings;
            if (sd) {
                sd.style.color = this.addAlpha(fontColor, 0.4);
            }
        }
    }

    componentDidUpdate(props, state) {
        let el = document.getElementById("playSegment");
        const { fontColor } = props.bbSettings;
        if (el && (!scrollFlag || props.settings.panel.isPanelClosing)) {
            el.style.color = fontColor;

            el.scrollIntoView({
                block: 'center',
                inline: 'center'
            });
            scrollFlag = true;
            this.props.dispatch(settingsPanel(false));
        }
        if (el) {
            el.style.color = fontColor;
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
        }
    }

    componentWillUnmount() {
        scrollFlag = false;
    }

    render() {
        smoothscroll.polyfill();
        const { analysis, highlightWordIndex, allStorySegment, index } = this.props;
        const { fontColor, highlightColor, highlightMode, fontSize } = this.props.bbSettings
        var analysisWords = [];
        if (analysis && analysis.NBest) {
            analysisWords = analysis.NBest[0].Words;
        }
        return (
            <div className="innerSegmentContainer" style={{ fontSize: fontSize + "em" }}>
                {
                    allStorySegment &&
                    allStorySegment.map((segment, i) => {
                        let segmentArr = [];
                        if (i === index) {
                            segmentArr = segment.text.split(" ");
                            return (
                                <div key={i} id="playSegment" className="displayScroll_withFocus">
                                    {segmentArr.map((item, index) => {
                                        let wordStyle;
                                        let highlightToggle = false;
                                        let bgHighlight = {
                                            background: highlightColor,
                                            boxShadow: "0px 1px 3px #222, 0px 1px 1px #333",
                                            borderRadius: 4
                                        }
                                        if ((this.props.playRecording || this.props.playComputer) && (highlightWordIndex === index)) {
                                            highlightToggle = highlightMode;
                                        } else highlightToggle = false;
                                        if (analysisWords.length > 0) {
                                            let analysisWord = analysisWords[index];
                                            if (analysisWord && analysisWord.AccuracyScore < 90) {
                                                if (analysisWord.AccuracyScore < 50) {
                                                    wordStyle = "color1";
                                                } else {
                                                    wordStyle = "color2";
                                                }
                                            }
                                            return <span key={index} style={highlightToggle ? bgHighlight : { background: "" }} className={`${wordStyle}`}>{item} </span>
                                        } else {
                                            return <span key={index} style={highlightToggle ? bgHighlight : { background: "" }}  >{item} </span>
                                        }
                                    })
                                    }
                                </div>
                            )
                        }
                        return (
                            <div
                                key={i}
                                id='storyDisplay'
                                className="displayScroll"
                                style={{ color: this.addAlpha(fontColor, 0.4) }}
                            >
                                {segment.text}
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

const mapState = ({ platform: { settings } }) => {
    return {
        settings
    }
};

export default connect(mapState)(StoryPage);